export const CREATE_INVOICE = `
  mutation ($invoice: InvoiceInput!) {
          createInvoice(
            invoice: $invoice
          ) {
            data {
              breakdown {
                amount
                dateRange
                element1
                element4
              }
              credit
              id
              internal
              invoiceNumber
              month
              purchaseOrder
              tax
              total
              type
              usage
              vendor
              year
            }
            error {
              code
              message
              statusCode
            }
          }
        }
`
